import React from "react";
import "./Blog_pagination_holder.css";
import { Pagination } from "react-bootstrap";

function Blog_pagination_holder({ totalPages = 10, currentPage = 1, onPageChange }) {
  const renderPaginationItems = () => {
    let items = [];

    // First Page
    items.push(
      <Pagination.Item key={1} active={currentPage === 1} onClick={() => onPageChange(1)}>
        01
      </Pagination.Item>
    );

    // Second Page
    if (totalPages > 1) {
      items.push(
        <Pagination.Item key={2} active={currentPage === 2} onClick={() => onPageChange(2)}>
          02
        </Pagination.Item>
      );
    }

    // If there are more than 4 pages, add an ellipsis before the last page
    if (totalPages > 4) {
      items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
    }

    // Last Page
    if (totalPages > 2) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages.toString().padStart(2, "0")}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <section className="Blog_pagination_holder">
      <Pagination>
        <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} />
        {renderPaginationItems()}
        <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} />
      </Pagination>
    </section>
  );
}

export default Blog_pagination_holder;
